import React, { FC, Fragment } from 'react';
import { PageFooter } from 'components';
import {
  FuelTypography,
  FuelCheckbox,
  FuelTag,
  FuelButton,
  FuelDivider,
} from '@frete.com/fuel-react';
import { Template, Container, Wrapper, Heading } from './styled';
import { useFunctions } from './functions';

const options = [
  'Confirmei que o negociante é autorizado pela empresa e coletei detalhes sobre o frete e a carga.',
  'Comparei os valores do frete com a média de mercado.',
  'Confirmei os dados da empresa como nome, CNPJ, telefone e e-mail nos canais oficiais de atendimento.',
];

const SecurityVerification: FC = () => {
  const { handleNextStep, handleCancel, handleCheck, hasError, checkedState } =
    useFunctions();

  return (
    <Template>
      <Heading />
      <Wrapper>
        <FuelTag
          label="VERIFICAÇÃO DE SEGURANÇA"
          color="blue"
          iconStyle="filled"
          shape="ellipse"
          icon="shield"
        />
        <Container>
          <FuelTypography
            weight="bold"
            spacingTop={32}
            tag="h2"
            size="heading-lg"
            displayInline
          >
            Seu frete seguro! Preencha as próximas etapas para postá-lo
          </FuelTypography>

          {hasError && (
            <FuelTypography weight="bold" size="body-sm" color="danger-default">
              É necessário selecionar todas as opções para avançar.
            </FuelTypography>
          )}

          {options.map((option, index) => (
            <Fragment key={option}>
              <FuelCheckbox
                color="neutral-strong"
                label={option}
                checked={checkedState[index]}
                onFuel-change={() => handleCheck(index)}
              />

              {index < options.length - 1 && <FuelDivider />}
            </Fragment>
          ))}
        </Container>
      </Wrapper>

      <PageFooter disableStepsSwitcher>
        <FuelDivider />
        <FuelButton
          onClick={handleCancel}
          type="button"
          variant="tertiary"
          size="medium"
        >
          Cancelar
        </FuelButton>
        <FuelButton
          type="button"
          variant="primary"
          size="medium"
          trailingIcon="arrow-right"
          onClick={handleNextStep}
          disabled={hasError}
        >
          Avançar
        </FuelButton>
      </PageFooter>
    </Template>
  );
};

export default SecurityVerification;
